module.exports = __webpack_public_path__ + "media/src/images/mails/ffcc00-42f07ac01d5f1c1ef4c4133b3e82bba5.png";